const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
const layout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 16,
  },
};

export { layout, tailLayout };
